import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../../../Util/Session/session.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import * as XLSX from 'xlsx';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';
@Component({
  selector: 'app-login-initiation',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './login-initiation.component.html',
  styleUrl: './login-initiation.component.scss'
})
export class LoginInitiationComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  InitiationData: any[] = [];
  EmployeeType: string = 'Front';
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: number = 0;
  BranchName: string = '';
  ClientId: number = 0;
  ClientName: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  SiteCode: string = '';
  EmployeeCode: string = '';
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private leave: LeaveService,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }

  onSelectionChange(type: string, event: any) {
    if (type == 'EmployeeType') {
      this.EmployeeType = event.target.value;
    }
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = 0;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = 0
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = 0
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Load() {
    if (!this.BranchName || this.BranchName == '' || this.BranchId == 0) {
      console.log('Please select Branch');
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    this.getData();
  }
  getData() {
    this.User = this.sessionService.GetUserDetails();

  }
  Save() {
    if (this.InitiationData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return;
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Save?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.update();
      }
    }).catch(() => {
    });
  }
  update() {

  }

}
